import { Text } from "@ttc3k/trekker";
import React from "react";
import { PageActionItem } from "shared/components/molecules";
import { Flex } from "styled-system/jsx";

export type PageAction = {
  Icon: React.ForwardRefExoticComponent<
    Omit<React.SVGProps<SVGSVGElement>, "ref"> &
      React.RefAttributes<SVGSVGElement>
  >;
  key: string;
  text: string;
  buttonOpacity?: number;
  useAlternateInfo?: boolean;
  alternateInfo?: {
    Icon: React.ForwardRefExoticComponent<
      Omit<React.SVGProps<SVGSVGElement>, "ref"> &
        React.RefAttributes<SVGSVGElement>
    >;
    text: string;
  };
};

type PageActionsProps = {
  title: string;
  actions: PageAction[];
  keyToDisable?: string;
  onActionClick: (key: string) => void;
};

export const PageActions = ({
  title,
  actions,
  keyToDisable,
  onActionClick,
}: PageActionsProps) => (
  <Flex flexDir="column" gap="200">
    <Text visual="smallLabel" color="text.mid" pb="25">
      {title}
    </Text>
    {actions.map((action) => (
      <PageActionItem
        key={action.key}
        action={action}
        onClick={onActionClick}
        isLoading={keyToDisable === action.key}
      />
    ))}
  </Flex>
);
